// export const toVND = (totalFee: number) => `${(Math.round(+totalFee / 1000) * 1000).toLocaleString('vi-VN', {
//   currency: 'VND',
// })}đ`;
export const toVND = (totalFee: number) => `${(totalFee).toLocaleString('vi-VN', {
  currency: 'VND',
})}đ`;
